import {CanActivate, Router, ActivatedRouteSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {IModeleFormulaireWebServiceClient} from "@common/resources/resources";
/**
 * Created by asi on 17/10/19.
 */

@Injectable()
export class EnsureGestionModeleGuard implements CanActivate {

  constructor(private modeleFormulaireWebService: IModeleFormulaireWebServiceClient,
              private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot) {
    return new Promise((resolve) => {
      this.modeleFormulaireWebService.getAuthorizationAccessEdit(route.params['id']).subscribe(bool => {
        if (!bool) {
          this.router.navigateByUrl('/cerba/formulaires/admin');
        }
        resolve(bool);
      });
    })
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/gestion-modele/gestion-modele.guard.ts